import {
    DatasourceColumnId,
    ICompiledSQLTokens,
    IDatasourceSQLMap,
    mergeSqlTokensArray,
} from 'src/app/utils/datasource-sql-map/datasource';
import { DatePickerSqlTokensCompiler } from 'src/app/utils/datasource-sql-map/date-picker-sql-tokens-compiler';
import {
    multipleSelectComponentCompileSQLTokens,
    segmentContainerIdCompileSQLTokens,
} from 'src/app/utils/datasource-sql-map/utils';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import {
    IQueryContext,
    IQueryContextDatasourceColumn,
} from 'src/app/services/query-context/models/IQueryContext';
import { sqlDateTrunc } from 'src/app/utils/sql';
import { buildSplitGroupSQL, buildWhereSQL } from 'src/app/utils/query/sql';
import { TableSqlBuilderHelper } from 'src/app/components/table-dashboard-item/sql-builder-helper';
import { StringInputFilterDashboardItemComponent } from '../../common/items/filter/string-input-filter/string-input-filter.component';
import { BQSqlFunctionHelper } from 'src/app/utils/datasource-sql-map/bq-sql-function-helper';
import { MultipleSelectComponent } from 'src/app/components/multiple-select/multiple-select.component';

export class BiVizDashboardUsersActivity {
    public static sqlMap: IDatasourceSQLMap = {
        dataset: 'bi_viz',
        tableId: 'dashboard_users_activity',
        columns: {
            ACTIVITY_DATE: {
                columnId: 'ACTIVITY_DATE',
                columnSQL: 'date',
                compileSQLTokens: (state) => {
                    return DatePickerSqlTokensCompiler.compileTokens(
                        'date',
                        state
                    );
                },
            },
            ACTIVITY_APP_VERSION: {
                columnId: 'ACTIVITY_APP_VERSION',
                columnSQL: 'daily_app_version',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'daily_app_version',
                        state
                    );
                },
            },
            ACTIVITY_APP_VERSION_GROUP_MINOR: {
                columnId: 'ACTIVITY_APP_VERSION_GROUP_MINOR',
                columnSQL: `${BQSqlFunctionHelper.getCallSqlStatement(
                    BQSqlFunctionHelper.VERSION_HIERARCHY,
                    ['daily_app_version']
                )}.minor`,
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        `${BQSqlFunctionHelper.getCallSqlStatement(
                            BQSqlFunctionHelper.VERSION_HIERARCHY,
                            ['daily_app_version']
                        )}.minor`,
                        state
                    );
                },
            },
            ACTIVITY_DAY_NO: {
                columnId: 'ACTIVITY_DAY_NO',
                columnSQL: 'day_no',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'day_no',
                        state
                    );
                },
            },
            DAILY_AD_CONSENT: {
                columnId: 'DAILY_AD_CONSENT',
                columnSQL: 'daily_ad_consent',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'daily_ad_consent',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_UNIFIED_TRAFFIC: {
                columnId: 'FIRST_ATTRIBUTION_UNIFIED_TRAFFIC',
                columnSQL: 'user_dim.first_attribution.unified_traffic',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_traffic',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_UNIFIED_NETWORK: {
                columnId: 'FIRST_ATTRIBUTION_UNIFIED_NETWORK',
                columnSQL: 'user_dim.first_attribution.unified_network',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_network',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD: {
                columnId: 'FIRST_ATTRIBUTION_AD',
                columnSQL: 'user_dim.first_attribution.unified_ad',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_LENGTH_S: {
                columnId: 'FIRST_ATTRIBUTION_AD_LENGTH_S',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.length_s',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.length_s',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_SIZE: {
                columnId: 'FIRST_ATTRIBUTION_AD_SIZE',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.size',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.size',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_ASPECT_RATIO: {
                columnId: 'FIRST_ATTRIBUTION_AD_ASPECT_RATIO',
                columnSQL:
                    'user_dim.first_attribution.unified_ad_dim.aspect_ratio',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.aspect_ratio',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_TYPE: {
                columnId: 'FIRST_ATTRIBUTION_AD_TYPE',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.type',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.type',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_THEME: {
                columnId: 'FIRST_ATTRIBUTION_AD_THEME',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.theme',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.theme',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_AD_VERSION: {
                columnId: 'FIRST_ATTRIBUTION_AD_VERSION',
                columnSQL: 'user_dim.first_attribution.unified_ad_dim.version',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_ad_dim.version',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_ADSET: {
                columnId: 'FIRST_ATTRIBUTION_ADSET',
                columnSQL: 'user_dim.first_attribution.unified_adset',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_adset',
                        state
                    );
                },
            },
            FIRST_ATTRIBUTION_CAMPAIGN_ACTIVE: {
                columnId: 'FIRST_ATTRIBUTION_CAMPAIGN_ACTIVE',
                columnSQL: 'active_campaign',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.active_campaign',
                        state,
                        MultipleSelectComponent.toBooleanSQL
                    );
                },
            },
            FIRST_ATTRIBUTION_UNIFIED_CAMPAIGN: {
                columnId: 'FIRST_ATTRIBUTION_UNIFIED_CAMPAIGN',
                columnSQL: 'user_dim.first_attribution.unified_campaign',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_attribution.unified_campaign',
                        state
                    );
                },
            },
            DEVICES_SELECTED_FIRST_DEVICE_MODEL: {
                columnId: 'DEVICES_SELECTED_FIRST_DEVICE_MODEL',
                columnSQL: 'user_dim.first_device.model',
                compileSQLTokens: (state) => {
                    return StringInputFilterDashboardItemComponent.compileSqlTokens(
                        'user_dim.first_device.model',
                        state
                    );
                },
            },
            REVENUE_PAYER: {
                columnId: 'REVENUE_PAYER',
                columnSQL: 'user_dim.revenue.payer',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.revenue.payer',
                        state
                    );
                },
            },
            REVENUE_BADGE: {
                columnId: 'REVENUE_BADGE',
                columnSQL: 'user_dim.revenue.badge',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.revenue.badge',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY_EU: {
                columnId: 'FIRST_GEO_COUNTRY_EU',
                columnSQL: 'user_dim.first_geo.country_european_union',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_geo.country_european_union',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY_TIER: {
                columnId: 'FIRST_GEO_COUNTRY_TIER',
                columnSQL: 'user_dim.first_geo.country_tier_label',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_geo.country_tier_label',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY_IS_RELEVANT_LABEL: {
                columnId: 'FIRST_GEO_COUNTRY_IS_RELEVANT_LABEL',
                columnSQL: 'user_dim.first_geo.country_is_relevant_label',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_geo.country_is_relevant_label',
                        state
                    );
                },
            },
            FIRST_GEO_COUNTRY: {
                columnId: 'FIRST_GEO_COUNTRY',
                columnSQL: 'user_dim.first_geo.unified_country',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_geo.unified_country',
                        state
                    );
                },
            },
            FIRST_SESSION_DATE: {
                columnId: 'FIRST_SESSION_DATE',
                columnSQL: 'user_dim.first_session_date',
                compileSQLTokens: (state) => {
                    return DatePickerSqlTokensCompiler.compileTokens(
                        'user_dim.first_session_date',
                        state
                    );
                },
            },
            FIRST_APP_VERSION: {
                columnId: 'FIRST_APP_VERSION',
                columnSQL: 'user_dim.first_app.version',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_app.version',
                        state
                    );
                },
            },
            FIRST_APP_VERSION_GROUP_MINOR: {
                columnId: 'FIRST_APP_VERSION_GROUP_MINOR',
                columnSQL: `${BQSqlFunctionHelper.getCallSqlStatement(
                    BQSqlFunctionHelper.VERSION_HIERARCHY,
                    ['user_dim.first_app.version']
                )}.minor`,
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        `${BQSqlFunctionHelper.getCallSqlStatement(
                            BQSqlFunctionHelper.VERSION_HIERARCHY,
                            ['user_dim.first_app.version']
                        )}.minor`,
                        state
                    );
                },
            },
            FIRST_DEVICE_BRAND: {
                columnId: 'FIRST_DEVICE_BRAND',
                columnSQL: 'user_dim.first_device.brand',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_device.brand',
                        state
                    );
                },
            },
            FIRST_DEVICE_CATEGORY: {
                columnId: 'FIRST_DEVICE_CATEGORY',
                columnSQL: 'user_dim.first_device.category',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_device.category',
                        state
                    );
                },
            },
            FIRST_DEVICE_MODEL: {
                columnId: 'FIRST_DEVICE_MODEL',
                columnSQL: 'user_dim.first_device.model',
                compileSQLTokens: (state) => {
                    return multipleSelectComponentCompileSQLTokens(
                        'user_dim.first_device.model',
                        state
                    );
                },
            },
            SEGMENT: {
                columnId: 'SEGMENT',
                columnSQL: '_NOT_IMPLEMENTED_',
                compileSQLTokens: segmentContainerIdCompileSQLTokens,
            },
            SEGMENT_EXCLUDE: {
                columnId: 'SEGMENT_EXCLUDE',
                columnSQL: 'segments',
                compileSQLTokens: segmentContainerIdCompileSQLTokens,
            },
        },
    };

    // compile sql statements specific for this datasource
    public static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        const dateTrunc = queryContextSettings.dateAggregation
            ? sqlDateTrunc('date', queryContextSettings.dateAggregation)
            : `date`;

        // if app_version is present in QueryContext
        const is_in_context_app_version =
            supportedDatasourceColumns.findIndex(
                (dsCol) => dsCol.id === 'ACTIVITY_APP_VERSION'
            ) != -1;

        // if segment_container_id is present in splits or filters
        const is_in_context_segment =
            supportedDatasourceColumns.findIndex(
                (dsCol) => dsCol.id === 'SEGMENT'
            ) != -1;

        const sqlTokens: {
            id: DatasourceColumnId;
            compiledSqlTokens: Partial<ICompiledSQLTokens>;
        }[] = supportedDatasourceColumns.map((dsCol) => {
            return {
                id: dsCol.id,
                compiledSqlTokens: this.sqlMap.columns[dsCol.id]!
                    .compileSQLTokens!(dsCol.state, options),
            };
        });

        // merge tokens into single deduplicated object of type ICompiledSQLTokens
        const mergedSqlTokens: ICompiledSQLTokens = mergeSqlTokensArray(
            sqlTokens.map((sqlToken) => sqlToken.compiledSqlTokens)
        );

        // CUSTOM FILTER FOR THIS TABLE
        // sqlTokens.where.push(`validation_flag IS NULL`);

        // unnest app_version_activity if app_version is present in splits or filters
        // TODO to powinno być rozwiązane na poziomie datasource, gdzie compileSQL zwróci atrybut join, z treścią `, UNNEST...`

        const splitSelect: string = buildSplitGroupSQL(
            mergedSqlTokens.split_group
        );
        const splitGroupBy = splitSelect ? 'split_group, ' : '';

        // create splitSelect in the form: dsCol.columnSQL AS dsCol.id
        const splitSelectAsSeparateColumns =
            TableSqlBuilderHelper.getSplitSelect(sqlTokens);

        // create splitGroupBy in the form: dsCol.id
        const splitGroupByTable =
            TableSqlBuilderHelper.getSplitGroupBy(sqlTokens);
        const where: string = buildWhereSQL([
            ...mergedSqlTokens.where,
            ...(customCompiledSqlTokens?.where ?? []),
        ]);
        const join: string = mergedSqlTokens.join.join('\n');
        const windowTotal = splitGroupBy ? 'PARTITION BY split_group' : '';
        const windowRunning = splitGroupBy
            ? 'PARTITION BY split_group ORDER BY day_no'
            : 'ORDER BY day_no';

        return {
            dateTrunc,
            splitSelect,
            splitGroupBy,
            splitSelectAsSeparateColumns,
            splitGroupByTable,
            where,
            windowTotal,
            windowRunning,
            join,
        };
    }
}
